import { render } from "./ForgotPasswordCompany.vue?vue&type=template&id=b63301c4&scoped=true"
import script from "./ForgotPasswordCompany.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordCompany.vue?vue&type=script&lang=js"

import "@/assets/styles/login.css?vue&type=style&index=0&id=b63301c4&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b63301c4"]])

export default __exports__